import { getNotificationListDisplay } from "../lib/notificationListDisplay";

/**
 * Title + optional body for a notification row (dropdown or full page list).
 * @param {{ notification: object, showKicker?: boolean }} props
 */
export default function NotificationListItemContent({ notification, showKicker = false }) {
  const { kicker, heading, subtitle } = getNotificationListDisplay(notification);

  return (
    <>
      {showKicker && kicker ? (
        <span className="jw-notification-item__kicker">{kicker}</span>
      ) : null}
      {heading ? <span className="jw-notification-item__title">{heading}</span> : null}
      {subtitle ? <span className="jw-notification-item__body">{subtitle}</span> : null}
    </>
  );
}
